import { NoInfoDataBlock } from "./NoInfoDataBlock";
import { UploadDataBtn } from "../ui/buttons";

type Props = {
  campaign_id: string;
  totalAccounts: number;
};

export const NoUploadDataBlock = ({ campaign_id, totalAccounts }: Props) => {
  return (
    <NoInfoDataBlock
      campaign_id={campaign_id}
      totalAccounts={totalAccounts}
      title="No Accounts Data"
      description={
        "Share your target accounts and contacts data to unlock " +
        "buying committee insights and contacts engagement tracking."
      }
      buttonText="Upload Data"
      onClick={() => {}}
      btnBlock={<UploadDataBtn campaign_id={campaign_id} />}
    />
  );
};
